module.exports = __webpack_public_path__ + "static/media/prepaTEC-min.72c2d0cf.png";